import React, { useState } from 'react';
import { Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import HelpIcon from '@material-ui/icons/Help';
import InfoIcon from '@material-ui/icons/Info';

import { FormComponent } from 'shared';

function FormWithDisplay({ button, editable = true, formFields, onBreakdownClick, onSubmit, title }) {
    const useStyles = makeStyles((theme) => ({
        inputLabel: {
            paddingBottom: '10px',
            color: 'black',
            fontWeight: 'bold',
        },
    }));
    const classes = useStyles();

    const [editing, setEditing] = useState(false);

    const getMatchingOption = (item) => {
        const options = item.inputProps.opts;
        const match = options.find((opt) => !!opt.value && String(opt.value) === String(item.initialValue));
        if (match) {
            return match.text;
        }
        return item.initialValue;
    };

    return (
        <>
            <InputLabel
                className={classes.inputLabel}
                onClick={() => {
                    if (!editable) {
                        return;
                    }
                    setEditing(!editing);
                }}
            >
                <span style={{ paddingRight: '20px' }}>{title}</span>
                {editable && (
                    <span style={{ cursor: 'pointer' }}>
                        {editing ? (
                            <CloseIcon style={{ fontSize: '16px' }} />
                        ) : (
                            <EditIcon style={{ fontSize: '16px' }} />
                        )}
                    </span>
                )}
            </InputLabel>
            {editing ? (
                <FormComponent
                    button={button || null}
                    formFields={formFields}
                    inputElementStyle={{ padding: '0px', margin: '0px' }}
                    formControlStyle={{ padding: '0px 3px' }}
                    onSubmit={async (formData, resetForm) => {
                        const res = await onSubmit(formData);
                        if (res) {
                            setEditing(false);
                        }
                        return res;
                    }}
                />
            ) : (
                <Grid container alignItems="center" style={{ textAlign: 'left' }}>
                    {formFields.map((item) => (
                        <Grid item xs={12} md={item.gridValue || 12} key={item.name} style={{ padding: '5px' }}>
                            <InputLabel shrink style={{ display: 'flex', alignItems: 'center' }}>
                                {item.label}
                                {item.showTooltip && (
                                    <Tooltip title={item.tooltipText} arrow>
                                        <HelpIcon style={{ fontSize: '16px', marginLeft: '4px', color: '#666' }} />
                                    </Tooltip>
                                )}
                            </InputLabel>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span>
                                    {item.inputProps?.opts ? `${getMatchingOption(item)}` : `${item.initialValue}`}
                                </span>
                                {item.showBreakdown && onBreakdownClick && (
                                    <Tooltip title="View breakdown details" arrow>
                                        <IconButton
                                            size="small"
                                            onClick={() => onBreakdownClick(item)}
                                            style={{ marginLeft: '8px', padding: '4px' }}
                                        >
                                            <InfoIcon style={{ fontSize: '16px' }} />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </div>
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    );
}

export { FormWithDisplay };
